import { render, staticRenderFns } from "./PasoResumen.vue?vue&type=template&id=bec5d588"
import script from "./PasoResumen.vue?vue&type=script&setup=true&lang=js"
export * from "./PasoResumen.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports